export const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://api.syncroniza.cl' : 'http://localhost:5000';